module.exports = __webpack_public_path__ + "img/messenger.9f4c06a0.svg";